import { makeSlotKey, readEventId } from "../store/eventIdentity";

export function createReservationSlotResolver({
   dayIndexByKey,
   getReservationStartRaw,
   extractYmdPrefix,
   toFloatingDate,
   formatDateKeyInChisinau,
   formatTimeLabelInChisinau,
   normalizeHourMinuteLabel,
   findNearestTimeSlotLabel,
   normalizedTimeLabels,
   timeLabelMinutes,
   getReservationColumnInstructorId,
   lateralInstructorId = "__lateral__",
}) {
   return function resolveReservationSlotKey(row) {
      if (!row || typeof row !== "object") return "";

      const preset = String(row.__slotKey || "").trim();
      if (preset) return preset;

      const startRaw = getReservationStartRaw?.(row);
      const ymd =
         extractYmdPrefix?.(startRaw) ||
         formatDateKeyInChisinau?.(toFloatingDate?.(startRaw));
      const dayIndex = dayIndexByKey?.get?.(String(ymd || "").trim());
      if (!Number.isFinite(dayIndex)) return "";

      const instructorId = String(
         getReservationColumnInstructorId?.(row) || "",
      ).trim();
      if (!instructorId) return "";

      const sourceLabel = normalizeHourMinuteLabel?.(
         formatTimeLabelInChisinau?.(startRaw) || "",
      );
      if (!sourceLabel) return "";

      const slotLabel =
         instructorId === lateralInstructorId
            ? sourceLabel
            : findNearestTimeSlotLabel?.(
                 sourceLabel,
                 normalizedTimeLabels,
                 timeLabelMinutes,
              ) || sourceLabel;

      return makeSlotKey(dayIndex, instructorId, slotLabel);
   };
}

export function hydrateCalendarStoreFromRows(store, {
   monthKey = "",
   items = [],
   serverTime = "",
   slotResolver,
} = {}) {
   if (!store) return;
   store.hydrateFromServer({
      monthKey,
      items,
      serverTime,
      slotResolver,
   });
}

export function buildLiveRowsForPipeline(store, fallbackRows = []) {
   if (!store) return Array.isArray(fallbackRows) ? fallbackRows : [];
   const rows = store.getEventsList();
   if (rows.length) return rows;
   return Array.isArray(fallbackRows) ? fallbackRows : [];
}

export function storeHasEvent(store, eventId) {
   if (!store) return false;
   return !!store.getEventById(readEventId(eventId));
}
